import { E as EMPTY_VALUES } from './constants-8d548297.js';

function checkNonEmpty(value, error) {
    if (EMPTY_VALUES.some(v => v === value)) {
        throw new Error(error);
    }
}

export { checkNonEmpty as c };
